<script>
import appConfig from "@/app.config";
export default {
  data() {
    return {
      assetsPath: appConfig.assetsPath,
    };
  },
};
</script>

<template>
  <div
    :class="$style.helpSupport"
    class="w-100 d-inline-block"
    id="helpSupport_animate"
  >
    <b-container>
      <div :class="$style.helpBlock">
        <b-row class="text-center">
          <b-col sm="12" md="8" lg="8" xl="8">
            <b-row
              class="flex-column-reverse flex-md-row flex-lg-row text-center"
            >
              <b-col
                sm="12"
                md="6"
                lg="6"
                xl="6"
                :class="$style.gap"
                class="flex-row d-flex justify-content-center align-items-end px-lg-5 px-md-2"
              >
                <div class="d-inline-block text-center">
                  <div :class="$style.iconBlock">
                    <img :src="assetsPath + 'images/icons/letter-icon.svg'" />
                  </div>
                  <h3 class="heading-3">{{ $t("helpSupport.contactUs") }}</h3>
                  <p>{{ $t("helpSupport.contactDesp") }}</p>
                  <div class="d-inline-block w-100">
                    <a
                      href="mailto:support@drpanda.com"
                      class="btn btn-info btn-lg rounded-half"
                    >
                      {{ $t("helpSupport.emailNow") }}
                    </a>
                  </div>
                </div>
              </b-col>

              <b-col
                col
                cols="12"
                sm="12"
                md="6"
                lg="6"
                xl="6"
                :class="$style.gap"
                class="d-flex justify-content-center align-items-end"
              >
                <div
                  class="d-inline-block text-center"
                  :class="$style.signupBox"
                >
                  <!-- <picture :class="$style.signUpPanda">
                    <source
                      :srcset="assetsPath + 'images/webp/panda-photo-1@2x.webp'"
                      type="image/webp"
                    />
                    <source
                      :srcset="assetsPath + 'images/panda-photo-1@2x.png'"
                      type="image/jpeg"
                    />
                    <img :src="assetsPath + 'images/panda-photo-1@2x.png'" />
                  </picture> -->
                  <!-- <div :class="$style.borderBox" class="rounded-14">
                    <h3
                      class="heading-3 px-lg-2"
                      v-html="$t('helpSupport.stayIn')"
                    />
                    <p v-if="$i18n.locale == 'en'">
                      {{ $t("helpSupport.signUp") }}
                    </p>
                    <div
                      class="d-inline-block w-100"
                      :class="$style.inputBlock"
                      v-if="$i18n.locale == 'en'"
                    >
                      <form
                        action="https://drpandagames.us5.list-manage.com/subscribe/post"
                        method="POST"
                      >
                        <input
                          type="hidden"
                          name="u"
                          value="2bf250831d7ce25f1e4cfe714"
                        />
                        <input type="hidden" name="id" value="b09a6b0a5e" />
                        <b-form-input
                          v-bind:placeholder="$t('helpSupport.emailAddress')"
                          class="form-control-lg rounded-14"
                          :class="$style.inputHeight"
                          type="email"
                          name="MERGE0"
                          id="MERGE0"
                        ></b-form-input>
                        <img :src="assetsPath + 'images/icons/light-gray-arrow-icon.svg'" />
                        <input
                          type="submit"
                          value=""
                          :style="{
                            position: 'absolute',
                            top: '24px',
                            right: '28px',
                            width: '16px',
                            height: '16px',
                            border: 'none',
                            background: `url(${assetsPath}images/icons/light-gray-arrow-icon.svg) left top no-repeat`,
                          }"
                        />
                      </form>
                    </div>
                    <div v-if="$i18n.locale == 'zh'">
                      <img :src="assetsPath + 'images/wechat-qr-code.png'" />
                    </div>
                  </div> -->
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col
            sm="12"
            md="4"
            lg="4"
            xl="4"
            class="align-items-end px-lg-4 px-md-2 p-sm-2"
            :class="$style.getHelpSupportBox"
          >
            <div class="d-inline-block text-center">
              <div :class="$style.iconBlock">
                <img :src="assetsPath + 'images/icons/support-icon.svg'" />
              </div>
              <h3 class="heading-3">{{ $t("helpSupport.support") }}</h3>
              <p>{{ $t("helpSupport.supportDesp") }}</p>
              <div class="d-inline-block w-100">
                <a
                  href="https://drpanda.zendesk.com/hc/en-us"
                  class="btn btn-info btn-lg rounded-half"
                  target="_blank"
                >
                  {{ $t("helpSupport.help") }}
                </a>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";

.helpSupport {
  padding: 40px 0 40px;
  background-color: $white;
}
.helpBlock {
  h3 {
    font-size: 24px;
    font-family: $family-bold;
    margin-top: 30px;
    margin-bottom: 20px;
  }
  p {
    margin-bottom: 30px;
    line-height: 28px;
    color: #514f50;
  }
}
.iconBlock {
  display: inline-block;
  height: 62px;
}
.signupBox {
  position: relative;
  padding-top: 210px;
  .signUpPanda {
    position: absolute;
    width: 180px;
    left: 0;
    right: 0;
    margin: auto;
    top: 0;
  }
  .borderBox {
    border: 3px solid $color-primary;
    background-color: $white;
    padding: 40px 32px;
    position: relative;
  }
  .inputHeight {
    height: 64px;
    font-size: 18px;
  }
  .inputBlock {
    position: relative;
    img {
      position: absolute;
      right: 26px;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 16px;
      cursor: pointer;
    }
  }
}
.gap {
  padding-bottom: 0px;
}
@media only screen and (max-width: 767px) {
  .gap {
    padding-bottom: 80px;
  }
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .signupBox {
    .inputHeight {
      font-size: 12px;
    }
    .inputBlock {
      img {
        width: 12px;
      }
    }
  }
}
@media only screen and (min-width: 767px) {
  .getHelpSupportBox {
    display: flex !important;
  }
}
</style>
